// Libraries
var React = require('react');

// Components
var CallToAction = require('../../common/CallToAction/CallToAction');

// Styles
require('./NotFoundModule.scss');

class NotFoundModule extends React.Component {
	componentDidMount() {
		const picturefill = require('picturefill');	
		picturefill();
	}

	render() {		
		return (
			<div className="NotFound">
				<div className="NotFound__container">
					<h1 className="NotFound__title">{this.props.data.title}</h1>
					<p className="NotFound__description">{this.props.data.description}</p>
					<div className="NotFound__number">404</div>
					<CallToAction {...this.props.data.link} shade="light" />
				</div>
				<div className="NotFound__image">
					<picture>
						<source media="(max-width: 500px)" srcSet={this.props.data.backgroundImage.smallUrl} />
						<source media="(max-width: 660px)" srcSet={this.props.data.backgroundImage.mediumUrl} />
						<source media="(max-width: 1000px)" srcSet={this.props.data.backgroundImage.largeUrl} />
						<source media="(max-width: 1600px)" srcSet={this.props.data.backgroundImage.extraLargeUrl} />
						<img src={this.props.data.backgroundImage.url} alt={this.props.data.backgroundImage.altText} />
					</picture>
				</div>
			</div>
		)
	}
}

module.exports = NotFoundModule;



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFoundModule.js